import { connect, Dispatch } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';
import { NewDriveItemsState } from '../../DriveItemList/New/reducer';
import { fetchNewDriveItems } from '../../DriveItemList/New/actions';

interface NewDriveItemListPageProps extends AbstractDriveItemListPageProps {
	dispatch: Dispatch<StoreState>;
	newDriveItems: NewDriveItemsState;
}

export class NewDriveItemListPage extends AbstractDriveItemListPage<NewDriveItemListPageProps> {

	headerLabel = 'messages.new';
	noItemsLabel = 'messages.no_new';
	showUnreadBadge = true;

	constructor(props: NewDriveItemListPageProps) {
		super(props);

		const { dispatch, newDriveItems } = props;
		const { isFetching } = newDriveItems;

		if (!isFetching) {
			dispatch(fetchNewDriveItems());
		}
	}

	initializeView(props: NewDriveItemListPageProps): void {
		return;
	}

	getDriveItemIds(): number[] {
		const { newDriveItems: { ids } } = this.props;
		return ids;
	}

	isFetching(): boolean {
		return this.props.newDriveItems.isFetching;
	}

	renderAdditionalItems(): JSX.Element[] | null {
		return null;
	}

	getAdditionalItemsLength(): number {
		return 0;
	}
}

const mapStateToProps = (state: StoreState) => {
	const { newDriveItems } = state;
	return { newDriveItems };
};

export default connect(mapStateToProps)(NewDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/New.tsx